import { render, staticRenderFns } from "./CustomFormTextBlockElement.vue?vue&type=template&id=2ce9b3a0"
import script from "./CustomFormTextBlockElement.vue?vue&type=script&lang=js"
export * from "./CustomFormTextBlockElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports